<template>
  <div>
    <Head title="Sorting" />
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-orange-400 hover:text-orange-600" href="/sorting-issuances">Sorting Items <!--{{ componentsData }} --></Link>
      <span class="text-orange-400 font-medium">/</span> Edit
    </h1>
    <div class="bg-white rounded-md shadow overflow-hidden">

      <form @submit.prevent="store">
        <div
            v-for="(sorting, index) in form.sortings"
            :key="index"
            class="grid grid-cols-4 p-2"
        >
          <div class="pb-2 pr-6 w-full lg:w-4/4">
            <text-input
                v-model="sorting.part_number"
                :key="index"
                :error="form.errors.part_number"
                placeholder="Scan Part Number"
            />
            <span
              v-if="isValidationErrors(`sortings.${index}.part_number`)"
              class="mt-3"
            >
              <span class="form-error">{{ showValidationErrors(`sortings.${index}.part_number`) }}</span>
            </span>
          </div>
          <!--
          <div class="pb-2 pr-6 w-full lg:w-4/4">
            <select-input
              v-model="sorting.part_number"
              :key="index"
              :error="form.errors.part_number"
              class="pb-0"
            >
              <option :value="null">
                -Select part number-
              </option>
              <option
                v-for="cmp in components"
                :key="cmp.id"
                :value="cmp.id"
              >
                {{ cmp.name }}
              </option>
            </select-input>
            <span
              v-if="isValidationErrors(`sortings.${index}.part_number`)"
              class="mt-3"
            >
              <span class="form-error">{{ showValidationErrors(`sortings.${index}.part_number`) }}</span>
            </span>
          </div>
        -->
          <div class="pb-2 pr-6 w-full lg:w-4/4">
            <select-input
              :key="index"
              v-model="sorting.destination"
              :error="form.errors.location"
            >
              <option
                v-for="destination in destinations"
                :key="destination"
                :value="destination"
              >
                {{ destination }}
              </option>
            </select-input>
            <span
              v-if="isValidationErrors(`sortings.${index}.destination`)"
              class="mt-3"
            >
              <span class="form-error">{{ showValidationErrors(`sortings.${index}.destination`) }}</span>
            </span>
          </div>
          <div class="pb-2 pr-6 w-full lg:w-4/4">
            <text-input
                :key="index"
                v-model="sorting.quantity"
                :error="form.errors.quantity"
                placeholder="Quantity"
            />
            <span
              v-if="isValidationErrors(`sortings.${index}.quantity`)"
              class="mt-3"
            >
              <span class="form-error">{{ showValidationErrors(`sortings.${index}.quantity`) }}</span>
            </span>
          </div>
          <div class="pb-2 pr-6 w-4/4 lg:w-4/4">
            <div class="w-full lg:w-1/2">
              <svg
                v-show="form.sortings.length > 1"
                @click="removeSorting(index, form.sortings)"
                xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" style="color: red;">
                <path stroke-linecap="round" stroke-linejoin="round" d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </div>
            <div class="w-full lg:w-1/2">
              <svg
                v-show="index === countSortings"
                @click="addSorting"
                xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3m0 0v3m0-3h3m-3 0H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </div>
          </div>
        </div>
        <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button :loading="form.processing" class="btn-orange" type="submit">Save</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  components: {
    Head,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
  },
  layout: Layout,
  remember: 'form',
  props: {
    components: Object,
    itemObj: Object,
    destinations: Array,
    sortedItems: Array,
  },
  data() {
    return {
      form: this.$inertia.form({
        /*componentData: {
          id: null,
          name: null,
          value: null,
          destination: null,
        },*/
        sortings: [{
          part_number: null,
          destination: null,
          quantity: null,
        }],
      }),
    }
  },
  computed: {
    componentsData() {
      const typesObj = []
      console.log(this.sortedItems)
      this.sortedItems.forEach((item) => {
        typesObj.push({
          id: item.id, part_number: item.part_number, quantity: item.quantity, destination: item.destination,
        })
      })
      this.form.sortings = typesObj
      console.log(this.form.sortings)
      return typesObj || []
    },
    countSortings() {
      if (this.form.sortings.length === 0) {
        return 0;
      }
      return this.form.sortings.length - 1;
    },
  },
  methods: {
    store() {
      this.form.post(`/manufacturing-issuances/${this.itemObj.id}/sorted-items`)
    },
    addSorting(e) {
      e.preventDefault();
      this.form.sortings.push({
        part_number: null,
        destination: null,
        quantity: null,
      });
    },
    removeSorting(index, sortings) {
      sortings.splice(index, 1)
    },
    isValidationErrors(value) {
      if (this.form.errors) {
        const error = this.form.errors[value] || '';
        return !!error;
      }
      return false;
    },
    showValidationErrors(value) {
      if (this.form.errors) {
        const error = this.form.errors[value] || '';
        return error || '';
      }
      return '';
    },
  },
}
</script>
